import { render, staticRenderFns } from "./SourceMenu.vue?vue&type=template&id=7b7dbe6f&scoped=true&"
import script from "./SourceMenu.vue?vue&type=script&lang=js&"
export * from "./SourceMenu.vue?vue&type=script&lang=js&"
import style0 from "./SourceMenu.vue?vue&type=style&index=0&id=7b7dbe6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7dbe6f",
  null
  
)

export default component.exports